import { _ } from "../../../../polyglot/polyglot.js";
import { sanitizeWysiwygEditorHtml } from "../../../../helpers/string-util.js";
import textareaFieldWidget from "../textareaFieldWidget.js";
import WysiwygEditorWidget from "../../../WysiwygEditorWidget/WysiwygEditorWidget.js";

/**
 * `wysiwygFieldWidget` is a custom form field with rich editing
 * capabilities.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @param {Renderer} [placeholder] - Text to display in the field before the
 *   user enters anything
 * @param {string} [value] - Text in the editable area
 * @param {boolean} [toolbarAlwaysVisible] - When true, the medium toolbar is
 *   always visible, regardless of the focus of the editor
 * @param {PeriodReportDefaultText[]} defaultTexts - List of default text that can
 *   be inserted in the editor
 * @param {InputValueActionBuilder} [inputValueActionBuilder] - Builder for input values.
 *   When provided, it will add all the actions required to the WYSIWYG editor
 */
function wysiwygFieldWidget(spec, my) {
	spec ||= {};
	my ||= {};

	my.placeholder = spec.placeholder || _("Please add a comment");

	const that = textareaFieldWidget(spec, my);

	const initialContent = spec.value || spec.accessor();
	my.originalValue = initialContent;

	my.editor = new WysiwygEditorWidget({
		name: spec.name,
		content: my.originalValue,
		defaultTexts: spec.defaultTexts,
		onChange: (value) => (my.value = value),
		inputValueActionBuilder: spec.inputValueActionBuilder,
	});

	my.value = my.originalValue;

	that.getValue = function () {
		if (!my.editor) {
			return my.originalValue;
		}

		return my.value;
	};

	that.setValue = function () {
		if (!my.editor || !my.originalValue) {
			return;
		}

		my.editor.replaceWholeTextWithHTML(
			sanitizeWysiwygEditorHtml(my.originalValue),
		);
	};

	my.renderFieldOn = function (html) {
		html.render({ klass: "wysiwyg-field" }, my.editor);
	};

	return that;
}

export default wysiwygFieldWidget;
